
import { hpaFBConversionsAPI, forceInt, forceFloat, jsonParse } from "../functions";

$(function() {
    const fbSendEvents = window.FBPixelDefined;

    if (window.GtmDefined) {
        const sendToGTM = $('.js-gtm-send').length;

        const dataLayerClear = function(key) {
            if (key != '') {
                // https://developers.google.com/tag-manager/enhanced-ecommerce#clear-ecommerce
                const data = {};
                data[key] = null;
                window.dataLayer.push(data);  // Clear the previous ecommerce object.
            }
        };
        const dataLayerClearEcommerce = function() {
            dataLayerClear('ecommerce');
        };

        let gtmData = {};

        // console.log('GTM', window.GtmDefined, 'member data');
        if (gtmMemberData !== false) {
            const userEvent = {
                'event': 'user',
                'userData': gtmMemberData,
            };
            window.dataLayer.push(userEvent);
            dataLayerClear('userData');

            const coursesEvent = {
                'event': 'courses',
                'courseData': gtmMemberCourses,
            };
            window.dataLayer.push(coursesEvent);
            dataLayerClear('courseData');
        }

        // const productImpressions = $('.js-ga_addImpression');
        // // adding the impressions ( from Course List pages )
        // if (productImpressions.length) {
        //     // https://developers.google.com/tag-manager/enhanced-ecommerce#product-impressions
        //     const impressionFieldObjects = [],
        //         pageTitle = $('#js-pageTitle').text();
        //     let position = 1;
        //
        //     productImpressions.each(function() {
        //         const $this = $(this),
        //             impressionObject = JSON.parse($this.attr('data-ga_productInfo'));
        //         impressionFieldObjects.push({
        //             'name': impressionObject.name,
        //             'id': impressionObject.id,
        //             'price': impressionObject.price,
        //             'category': impressionObject.category,
        //             'list': pageTitle,
        //             'position': position
        //             // 'variant': 'practical reflash tuning',
        //        });
        //        position++;
        //     });
        //
        //     dataLayerClearEcommerce();  // Clear the previous ecommerce object.
        //
        //     gtmData = {
        //         'ecommerce': {
        //             'impressions': impressionFieldObjects
        //         }
        //     };
        //     // console.log(gtmData);
        //     window.dataLayer.push(gtmData);
        // }

        const clickIntoCourseEntry = $('.js-ga_clickIntoCourseEntry[data-gtm-products]');
        // Adding the click event from a course list clicking into a product Detail Page
        if (clickIntoCourseEntry.length) {
            clickIntoCourseEntry.on('touch click', function(e) {
                // AdBlocker - Ad blocker fix. "document.location = href;" doesn't work
                // e.preventDefault();

                const $this = $(this),
                    href = $this.attr('href'),
                    products = JSON.parse($this.attr('data-gtm-products'));
                // console.log('[GTM debug] clickIntoCourseEntry products:', products, this);

                dataLayerClearEcommerce();  // Clear the previous ecommerce object.

                // https://developers.google.com/tag-manager/enhanced-ecommerce#product-clicks
                gtmData = {
                    'event': 'eec.productClick', // name of an event. In this case, always stays as eec.productClick
                    'ecommerce': { // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                        'click': { // name of an action. In this case, always stays as click
                            'actionField': {
                                'list': products[0].brand //name of a list in which the product was clicked
                            },
                            'products': products
                        }
                    },
                    'eventTimeout' : 2000
                };
                // console.log(gtmData);
                window.dataLayer.push(gtmData);

                // AdBlocker - Ad blocker fix. "document.location = href;" doesn't work
                // document.location = href;
            });
        }

        // only use elements that carry the GTM data - CMS content can contain copies of the button without it
        const productDetails = $('.js-addProductDetail[data-gtm-products]').first();
        // adding the product Detail from the Course Entry Page
        // console.log('[GTM debug] .js-addProductDetail total:', $('.js-addProductDetail').length, 'with data-gtm-products:', productDetails.length, productDetails[0]);
        if (productDetails.length) {
            // https://developers.google.com/tag-manager/enhanced-ecommerce#details
            const products = JSON.parse(productDetails.attr('data-gtm-products'));
            // console.log('[GTM debug] productDetail products:', products);
            if (products && products.length) {
                gtmData = {
                    'event': 'eec.productDetail',
                    'ecommerce': {
                        'detail': {
                            'actionField': {
                                'list': products[0].brand
                            },
                            'products': products
                        }
                    }
                };
                // console.log(gtmData);
                window.dataLayer.push(gtmData);
            }

            if (window.RedditPixelDefined) {
                rdt('track', 'ViewContent');
            }

            const productInfo = jsonParse(productDetails.attr('data-ga_productInfo'));
            // console.log('[GTM debug] productDetail productInfo:', productInfo);
            if (productInfo) {
                if (fbSendEvents) {
                    // The same data as the Conversions API ViewContent event (see ControllerExtension::afterCallActionHandler())
                    const fbqData = {
                        event: 'ViewContent',
                        data: {
                            value: forceFloat(productInfo.price),
                            currency: 'USD',
                            content_ids: [productInfo.id],
                            content_type: 'product',
                            product_id: productInfo.id
                        }
                    };
                    if (productInfo.category) {
                        fbqData.data.content_category = productInfo.category;
                        fbqData.data.product_type = productInfo.category;
                    }

                    // console.log(fbqData);
                    fbq('track', fbqData.event, fbqData.data, { eventID: fbEventID });
                }

                const ttProductData = {
                    content_type: 'product',
                    content_id: productInfo.id,
                    content_category: productInfo.category,
                    content_name: productInfo.name,
                    price: productInfo.price,
                    quantity: productInfo.quantity,
                    value: productInfo.price,
                    currency: 'USD',
                };
                // console.log('tt ViewContent', ttProductData);
                if (window.TiktokPixelDefined) {
                    window.ttq.track('ViewContent', ttProductData);
                }
            }
        }

        $('.js-triggerPurchaseButton').on('touch click', function(e) {
            e.preventDefault();
            // $('.js-ga_addProductToCart').trigger('click');
            $('.js-ga_addProductToCart')[0].click(); // Use this instead. The jQuery .trigger('click') will call event handlers that you've bound but not cause the default click behaviour.
        });

        var clickCourseEntryIntoCart = $('.js-ga_addProductToCart[data-gtm-products]');
        // Adding the click event from a Course Entry Page into the Cart
        // When already logged in
        if (clickCourseEntryIntoCart.length) {
            clickCourseEntryIntoCart.on('touch click', function(e) {
                const $this = $(this),
                    form = $this.closest('form'),
                    products = JSON.parse($this.attr('data-gtm-products')),
                    href = $this.attr('href'),
                    comboPurchaseForm = $('#ComboPurchaseForm_ComboPurchaseForm');
                // console.log('[GTM debug] addProductToCart products:', products, this);

                // AdBlocker - Ad blocker fix. "document.location = href;" doesn't work so don't won't to prevent the link from clicking through.
                if ($this.hasClass('trigger-register') || $this.hasClass('trigger-register-starterPackage') || form.length) {
                    e.preventDefault();
                }

                let buttonType = $this.prop('tagName').toLowerCase(),
                    buttonText = (buttonType === 'input' ? $this.val() : $this.html()),
                    buttonTextNew = 'Loading...',
                    runEec = true;

                let productVariant = '';
                if (comboPurchaseForm.length) {
                    const productVariantField = comboPurchaseForm.find('select[name=OptionalCourses1]');
                    if (productVariantField.length) {
                        productVariant = productVariantField.val();
                        if (productVariant.length) {
                            products.forEach(function(product, index) {
                                this[index]['variant'] = productVariant;
                            }, products); // use products as this
                        } else {
                            runEec = false;
                        }
                    }
                }

                if (runEec) {
                    if (window.RedditPixelDefined) {
                        rdt('track', 'AddToCart');
                    }

                    const productInfo = jsonParse($this.attr('data-ga_productInfo'));
                    if (productInfo) {
                        // The Facebook AddToCart event is now sent from the payment confirmation page, via the
                        // Conversions API (see PaymentController::doFbCheckoutEvents()) and the pixel (see fb.js),
                        // so it's sent for every purchase path, not only these buttons.
                        // if (fbSendEvents) {
                        //     const fbqData = {
                        //         event: 'AddToCart',
                        //         data: {
                        //             value: forceFloat(productInfo.price),
                        //             currency: 'USD',
                        //             content_ids: [productInfo.id],
                        //             content_type: 'product'
                        //         }
                        //     };
                        //
                        //     // console.log(fbqData);
                        //     fbq('track', fbqData.event, fbqData.data, { eventID: fbEventID });
                        //
                        //     hpaFBConversionsAPI({
                        //         event_id: fbEventID,
                        //         event_name: fbqData.event,
                        //         custom_data: fbqData.data,
                        //     });
                        // }

                        const ttProductData = {
                            content_type: 'product',
                            content_id: productInfo.id,
                            content_category: productInfo.category,
                            content_name: productInfo.name,
                            price: productInfo.price,
                            quantity: productInfo.quantity,
                            value: productInfo.price,
                            currency: 'USD',
                        };
                        // console.log('tt AddToCart', ttProductData);
                        if (window.TiktokPixelDefined) {
                            window.ttq.track('AddToCart', ttProductData);
                        }
                    }

                    dataLayerClearEcommerce();  // Clear the previous ecommerce object.

                    gtmData = {
                        'event': 'eec.addToCart',
                        'ecommerce': {
                            'add': {
                              'products': products
                            }
                        },
                        'eventTimeout' : 2000
                    };
                    // console.log(gtmData);
                    window.dataLayer.push(gtmData);

                    dataLayerClearEcommerce();  // Clear the previous ecommerce object.

                    gtmData = {
                        'event': 'eec.checkout',
                        'ecommerce': {
                            'checkout': {
                                'actionField': {
                                    'step': 1
                                },
                                'products': products
                            }
                        },
                        'eventTimeout' : 2000
                    };
                    // console.log(gtmData);
                    window.dataLayer.push(gtmData);

                    if (!$this.hasClass('trigger-register') && !$this.hasClass('trigger-register-starterPackage')) {
                        dataLayerClearEcommerce();  // Clear the previous ecommerce object.

                        gtmData = {
                            'event': 'eec.checkoutOption',
                            'ecommerce': {
                                'checkout_option': {
                                    'actionField': {
                                        'step': 1,
                                        'option': 'Already Logged In'
                                    }
                                }
                            },
                            'eventTimeout' : 2000
                        };
                        // console.log(gtmData);
                        window.dataLayer.push(gtmData);
                    }

                    addToCartHandleButtonClick();
                }


                function addToCartHandleButtonClick() {
                    if (form.length) {
                        if ($this.hasClass('trigger-register') || $this.hasClass('trigger-register-starterPackage')) {
                            // do nothing
                        } else {
                            form.submit();
                        }
                    } else {
                        if ($this.hasClass('trigger-register') || $this.hasClass('trigger-register-starterPackage')) {
                            // do nothing
                        } else {
                            // AdBlocker - Ad blocker fix
                            // document.location = href;
                        }
                    }
                }
            });
        }

        $('.js_facebookLoginLink, .js-loginModalSubmitButton, .js-registerModalSubmitButton').on('touch click', function(e) {
            const $this = $(this),
                isCheckout = $this.data('is-checkout');
            let checkoutActionOption = 'Unknown',
                sendToGTM = false; // stop it sending twice in the register / login combined modal

            if ($this.hasClass('js_facebookLoginLink')) {
                checkoutActionOption = 'Facebook';
                sendToGTM = true;
            } else if ($this.hasClass('js-registerModalSubmitButton')) {
                // checkoutActionOption = 'Site Register';
                checkoutActionOption = 'Site Register / Login Modal';
                sendToGTM = true;
            }
            // } else if ($this.hasClass('js-loginModalSubmitButton')) {
            //     checkoutActionOption = 'Site Login';
            // }

            if (isCheckout === '1' && sendToGTM) {
                dataLayerClearEcommerce();  // Clear the previous ecommerce object.

                gtmData = {
                    'event': 'eec.checkoutOption',
                    'ecommerce': {
                        'checkout_option': {
                            'actionField': {
                                'step': 1,
                                'option': checkoutActionOption
                            }
                        }
                    }
                };
                // console.log(gtmData);
                window.dataLayer.push(gtmData);
            }
        });

        // Check out Page, register products in cart first
        const gaCheckout = $('.js-ga_checkout');
        if (gaCheckout.length && sendToGTM) {
            dataLayerClearEcommerce();  // Clear the previous ecommerce object.

            gtmData = {
                'event': 'eec.checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {
                            'step': 2
                        }
                    }
                }
            };
            // console.log(gtmData);
            window.dataLayer.push(gtmData);

            const productInfo = (jsonParse(gaCheckout.attr('data-ga_productInfo')) || [])[0];
            if (productInfo) {
                // The Facebook InitiateCheckout event is now sent via the Conversions API
                // (see PaymentController::doFbCheckoutEvents()) and the pixel (see fb.js)
                // if (fbSendEvents) {
                //     const fbqData = {
                //         event: 'InitiateCheckout',
                //         data: {
                //             num_items: forceInt(productInfo.quantity),
                //             value: forceFloat(productInfo.price),
                //             currency: 'USD',
                //             content_ids: [productInfo.id],
                //             content_type: 'product'
                //         }
                //     };
                //
                //     // console.log(fbqData);
                //     fbq('track', fbqData.event, fbqData.data, { eventID: fbEventID });
                // }

                const ttProducts = {
                    contents: [{
                        content_type: 'product',
                        content_id: productInfo.id,
                        content_category: productInfo.category,
                        content_name: productInfo.name,
                        price: productInfo.price,
                        quantity: productInfo.quantity,
                        value: productInfo.price,
                        currency: 'USD',
                    }]
                };
                // console.log('tt InitiateCheckout', ttProducts);
                if (window.TiktokPixelDefined) {
                    window.ttq.track('InitiateCheckout', ttProducts);
                }
            }
        }

        // on a success transaction page
        var gaPaymentSuccess = $('#js-ga_paymentSuccess');
        if (gaPaymentSuccess.length) {
            let orderObject = JSON.parse(gaPaymentSuccess.attr('data-gtm-order'));

            dataLayerClearEcommerce();  // Clear the previous ecommerce object.
            gtmData = {
                'event': 'eec.purchase',
                'ecommerce': {
                  'purchase': {
                    'actionField': {
                      'id': orderObject.transactionReceiptNumber, // Transaction ID. Required for purchases and refunds.
                      //'affiliation': 'Online Store',
                      'revenue': orderObject.revenue,
                      //'tax':'0',
                      //'shipping': '0',
                      'coupon': orderObject.coupon,
                      'coupon_value': orderObject.couponValue,
                      'new_account': orderObject.isFirstPurchase
                    },
                    'products': orderObject.products
                  }
                }
            };
            window.dataLayer.push(gtmData);

            // The Facebook Purchase event is now sent via the Conversions API (see PaymentController::success())
            // and the pixel (see fb.js)
            // if (fbSendEvents) {
            //     const fbqData = {
            //         event: 'Purchase',
            //         data: {
            //             num_items: forceInt(orderObject.productQuantity),
            //             value: forceFloat(orderObject.revenue),
            //             currency: 'USD',
            //             content_ids: [orderObject.productId],
            //             content_type: 'product'
            //         }
            //     };
            //
            //     // console.log(fbqData);
            //     fbq('track', fbqData.event, fbqData.data, { eventID: fbEventID });
            // }

            if (window.RedditPixelDefined) {
                rdt('track', 'Purchase');
            }

            const ttProducts = {
                contents: [{
                    content_type: 'product',
                    content_id: orderObject.productId,
                    content_category: orderObject.category,
                    content_name: orderObject.productName,
                    price: orderObject.productPrice,
                    quantity: orderObject.productQuantity,
                    value: orderObject.revenue,
                    currency: 'USD',
                }]
            };
            // console.log('tt CompletePayment', ttProducts);
            if (window.TiktokPixelDefined) {
                window.ttq.track('CompletePayment', ttProducts);
            }
        }

    } // if GtmDefined
});



// WEBPACK FOOTER //
// ./js/modules/gtm.js